/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { DiscordMessageBody } from './DiscordMessageBody';
import {
    DiscordMessageBodyFromJSON,
    DiscordMessageBodyFromJSONTyped,
    DiscordMessageBodyToJSON,
    DiscordMessageBodyToJSONTyped,
} from './DiscordMessageBody';

/**
 * 
 * @export
 * @interface DiscordRelayMessageUpdateBody
 */
export interface DiscordRelayMessageUpdateBody {
    /**
     * 
     * @type {DiscordMessageBody}
     * @memberof DiscordRelayMessageUpdateBody
     */
    message: DiscordMessageBody;
    /**
     * Bot authentication token
     * @type {string}
     * @memberof DiscordRelayMessageUpdateBody
     */
    botToken: string;
}

/**
 * Check if a given object implements the DiscordRelayMessageUpdateBody interface.
 */
export function instanceOfDiscordRelayMessageUpdateBody(value: object): value is DiscordRelayMessageUpdateBody {
    if (!('message' in value) || value['message'] === undefined) return false;
    if (!('botToken' in value) || value['botToken'] === undefined) return false;
    return true;
}

export function DiscordRelayMessageUpdateBodyFromJSON(json: any): DiscordRelayMessageUpdateBody {
    return DiscordRelayMessageUpdateBodyFromJSONTyped(json, false);
}

export function DiscordRelayMessageUpdateBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): DiscordRelayMessageUpdateBody {
    if (json == null) {
        return json;
    }
    return {
        
        'message': DiscordMessageBodyFromJSON(json['message']),
        'botToken': json['botToken'],
    };
}

export function DiscordRelayMessageUpdateBodyToJSON(json: any): DiscordRelayMessageUpdateBody {
    return DiscordRelayMessageUpdateBodyToJSONTyped(json, false);
}

export function DiscordRelayMessageUpdateBodyToJSONTyped(value?: DiscordRelayMessageUpdateBody | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'message': DiscordMessageBodyToJSON(value['message']),
        'botToken': value['botToken'],
    };
}

